const SupplierActionTypes = {
  SET_SUPPLIERS: 'SET_SUPPLIERS',
  REMOVE_SUPPLIER: 'REMOVE_SUPPLIER',
};

export default SupplierActionTypes;
